import { jsx } from '@amazon/vinyl-tsx'
import { Link } from '@/components/Link'

interface ChipDef {
    readonly label: string
    readonly href: string
}

// Chip rail mirrors the green hornet "Playlists / Podcasts / Songs /
// Albums / Artists / Purchased / Audiobooks" filters at the top of
// the library home. Each chip is a Link so middle-click and long-
// press surface the URL — they're not just observable toggles.
const CHIPS: readonly ChipDef[] = [
    { label: 'Playlists', href: '/my/playlists' },
    { label: 'Podcasts', href: '/my/podcasts' },
    { label: 'Songs', href: '/my/songs' },
    { label: 'Albums', href: '/my/albums' },
    { label: 'Artists', href: '/my/artists' },
    { label: 'Purchased', href: '/my/purchased' },
    { label: 'Audiobooks', href: '/my/audiobooks' },
]

export function LibraryChipNav() {
    return (
        <nav className="libraryChipNav" aria-label="Library categories">
            {...CHIPS.map((chip) => (
                <Link className="libraryChip" href={chip.href}>
                    {chip.label}
                </Link>
            ))}
        </nav>
    )
}
